import remainingChars from "surveylabJsAssets/page/_remaining-chars";
import likertSlider from "surveylabJsAssets/page/_likert-slider";

export default function () {
    remainingChars.initOnce();
    likertSlider.initOnce();
    $(function () {
        $('.sl-js-likert-horizontal-free').on('keyup change', function () {
            toggleRadio($(this));
        });
    });
}

function toggleRadio(textboxElement: JQuery): void {
    const containerElement = textboxElement.closest('.sl-js-item-row');
    const radioContainer = containerElement.find('.sl-js-radio');
    const radioElements = radioContainer.find('input[type="radio"]');
    const textboxValue = <string>textboxElement.val();
    if (textboxValue.length > 0) {
        radioElements.prop('disabled', false);
        radioContainer.removeClass('disabled');
    } else {
        radioElements.prop('disabled', true).prop('checked', false);
        radioContainer.addClass('disabled');
    }
}